export default __webpack_public_path__ + "static/media/order_sent.9fd5c4fa.wav";